/**
 * O parecer facial em vigor do caso, para a verificação item a item na revisão da face (E172.F4,
 * GUS-230 B2.3). Relido quando a versão da análise muda; sem parecer legível, `null` — a revisão
 * segue só com a decisão sobre a conclusão, e o laudo não afirma o protocolo.
 */
import type { AxiosInstance } from 'axios';
import { useEffect, useState } from 'react';

import { lerConferenciaFacial, type ConferenciaFacialParecerData } from './conferencia_facial';

export function useParecerFacial(
  client: AxiosInstance,
  caseId: string,
  versao: number,
): ConferenciaFacialParecerData | null {
  const [parecer, setParecer] = useState<ConferenciaFacialParecerData | null>(null);
  useEffect(() => {
    let vivo = true;
    lerConferenciaFacial(client, caseId)
      .then((lido) => {
        if (vivo) setParecer(lido.parecer);
      })
      .catch(() => {
        if (vivo) setParecer(null);
      });
    return () => {
      vivo = false;
    };
  }, [client, caseId, versao]);
  return parecer;
}
